import * as React from 'react';
import editSvg from '@ui/assets/edit.svg';
import removeSvg from '@ui/assets/remove.svg';

interface Props {
  width?: string;
  height?: string;
  onClick?: () => void;
  type: 'edit' | 'remove';
}

const getSvg = (type: string) => {
  switch (type) {
    case 'edit':
      return editSvg;
    case 'remove':
      return removeSvg;
    default:
      return undefined;
  }
};

const EditIcon: React.FunctionComponent<Props> = ({
  height = '22px',
  width = '22px',
  onClick = () => null,
  type,
}) => (
  <img
    src={getSvg(type)}
    alt="edit"
    style={{ height, width }}
    onClick={onClick}
  />
);

export default EditIcon;



// WEBPACK FOOTER //
// ./src/components/EditIcon/EditIcon.tsx